import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  IconButton,
  Typography,
  MenuItem,
  Menu,
  InputAdornment,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseCompetitors } from "./UseCompetitors";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { rsGotoLast, rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CachedIcon from "@mui/icons-material/Cached";
import { useSnackbar } from "notistack";

export default function Competitors() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { updatecost, getCompetitorDataList, getCompetitorList } =
    UseCompetitors();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { enqueueSnackbar } = useSnackbar();
  const [compotitorRes, setCompotitorRes] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const openD = Boolean(anchorEl);
  const [searchName, setSearchName] = useState("جستجو همه");
  const [searchColumn, setSearchColumn] = useState("");
  const [comDataRes, setComDataRes] = useState();
  const [openUpdate, setOpenUpdate] = useState(false);
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const [stateUpdate, setStateUpdate] = useState({
    productid: undefined,
    competitorID: undefined,
    take: 30,
    withDiscount: false,
    force: false,
    withStock: false,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getCompetitorList(
      myPc,
      searchColumn,
      search,
      (products) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(products.pageCondition.totalPage);
          return;
        }
        setCompotitorRes(products);
      },
      true
    );
  }, [myPc, searchColumn]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  useEffect(() => {
    if (openUpdate) {
      getCompetitorDataList((competitors) => {
        setComDataRes(competitors);
      });
    }
  }, [openUpdate]);

  const columns = [
    {
      field: "id",
      width: 90,
      headerName: "شماره",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "productName",
      headerName: " نام محصول ",
      width: 350,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "brandName",
      headerName: "نام برند",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.brandName}
          </Typography>
        );
      },
    },
    {
      field: "competitorCount",
      headerName: "تعداد رقبا ",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/competitors/editcompetitors", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="update">
              <IconButton
                onClick={() => {
                  setStateUpdate({
                    productid: [cellValues.row.id],
                    take: 30,
                    withDiscount: false,
                    force: false,
                    withStock: false,
                    competitorID: undefined,
                  });
                  setOpenUpdate(true);
                }}
              >
                <CachedIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box width="auto" display="flex" justifyContent="flex-start">
            <TextField
              placeholder={searchName}
              size="small"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
              InputProps={{
                autoComplete: "off",
                inputProps: {
                  min: 1,
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      id="basic-button"
                      aria-controls={openD ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={openD ? "true" : undefined}
                      onClick={(event) => setAnchorEl(event.currentTarget)}
                      edge="end"
                    >
                      <MoreVertIcon
                        fontSize="small"
                        sx={{ color: "MyColor.main" }}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openD}
              onClose={() => setAnchorEl(null)}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={() => {
                  setSearchName("جستجو همه");
                  setSearchColumn("");
                  setAnchorEl(null);
                }}
              >
                همه
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setSearchName("جستجو براساس نام محصول");
                  setSearchColumn("productName");
                  setAnchorEl(null);
                }}
              >
                نام محصول
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setSearchName("جستجو براساس برند");
                  setSearchColumn("BrandName");
                  setAnchorEl(null);
                }}
              >
                برند
              </MenuItem>
            </Menu>
          </Box>
        );
      },
    },
    {
      field: "update",
      width: 130,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Button
            onClick={() => {
              setStateUpdate({
                competitorID: undefined,
                take: 30,
                withDiscount: false,
                force: false,
                withStock: false,
              });
              setOpenUpdate(true);
            }}
            variant="contained"
            color="secondary"
          >
            به‌روزرسانی قیمت
          </Button>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/competitors" }],
      }}
    >
      <Dialog
        sx={{ zIndex: 200 }}
        fullWidth
        maxWidth="xs"
        open={openUpdate}
        onClose={() => {
          setStateUpdate({
            productid: undefined,
            competitorID: undefined,
            withDiscount: false,
            take: 30,
            force: false,
            withStock: false,
          });
          setOpenUpdate(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              // alignItems: "center",
              // justifyContent: "center",
              // mt: 1,
            }}
          >
            {comDataRes && (
              <Autocomplete
                id="combo-box-demo"
                options={comDataRes.competitors ? comDataRes.competitors : []}
                getOptionLabel={(competitors) =>
                  competitors.title ? competitors.title : ""
                }
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                fullWidth
                size="small"
                renderInput={(params) => <TextField {...params} label="رقیب" />}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {option.title ? option.title : ""}
                    </li>
                  );
                }}
                onChange={(evt, value) => {
                  if (value) {
                    setStateUpdate({ ...stateUpdate, competitorID: value.id });
                  } else {
                    setStateUpdate({ ...stateUpdate, competitorID: undefined });
                  }
                }}
              />
            )}
            {!stateUpdate.productid && (
              <TextField
                sx={{ input: { textAlign: "center" }, width: "40%" }}
                label="تعداد"
                value={stateUpdate.take}
                InputProps={{
                  inputProps: {
                    min: 1,
                  },
                }}
                type="number"
                onKeyDown={(e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                }}
                onChange={(evt) => {
                  const sanitizedValue = evt.target.value.replace(
                    /[^0-9.]/g,
                    ""
                  );
                  setStateUpdate({ ...stateUpdate, take: sanitizedValue });
                }}
                size="small"
                variant="outlined"
              />
            )}
            <FormControlLabel
              checked={
                stateUpdate.withDiscount ? stateUpdate.withDiscount : false
              }
              onChange={(evt) => {
                setStateUpdate({
                  ...stateUpdate,
                  withDiscount: evt.target.checked,
                });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="به‌روزرسانی تخفیفات"
            />
            <FormControlLabel
              checked={stateUpdate.force ? stateUpdate.force : false}
              onChange={(evt) => {
                setStateUpdate({
                  ...stateUpdate,
                  force: evt.target.checked,
                });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="به‌روزرسانی مجدد"
            />
            <FormControlLabel
              checked={stateUpdate.withStock ? stateUpdate.withStock : false}
              onChange={(evt) => {
                setStateUpdate({
                  ...stateUpdate,
                  withStock: evt.target.checked,
                });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="به‌روزرسانی موجودی"
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateUpdate.take || stateUpdate.take == 0) {
                    enqueueSnackbar("تعداد معتبر نیست", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  if (!stateUpdate.competitorID) {
                    enqueueSnackbar("رقیب را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }

                  console.log(stateUpdate);
                  setProgress(true);
                  updatecost(stateUpdate, () => {
                    if (stateUpdate.productid) {
                      setStateUpdate({
                        productid: undefined,
                        competitorID: undefined,
                        withDiscount: false,
                        take: 30,
                        force: false,
                        withStock: false,
                      });
                      setOpenUpdate(false);
                    }
                  });
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => {
                  setStateUpdate({
                    productid: undefined,
                    competitorID: undefined,
                    withDiscount: false,
                    take: 30,
                    force: false,
                    withStock: false,
                  });
                  setOpenUpdate(false);
                }}
                color="secondary"
                variant="outlined"
              >
                بستن
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {compotitorRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={compotitorRes.pageCondition.pageCount}
          rows={compotitorRes.products}
          paginationMode="server"
          page={compotitorRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            compotitorRes?.pageCondition.totalItemCount
              ? compotitorRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              nofab: true,
              isLtr: true,

              rowCount: compotitorRes.pageCondition.totalItemCount
                ? compotitorRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
